import { render, staticRenderFns } from "./StudentsEdit.vue?vue&type=template&id=12a30f5f&"
import script from "./StudentsEdit.vue?vue&type=script&lang=ts&"
export * from "./StudentsEdit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports